const TEST_LISTING_PATTERN = /\b(map\s*test|test\s*city|test\s*listing)\b/i;

export const isTestListing = (listing) => {
  if (!listing) return true;
  const title = String(listing.title || "").trim();
  if (!title) return true;
  if (TEST_LISTING_PATTERN.test(title)) return true;

  const city = String(listing.location?.city || "").trim();
  if (/^test\s+city$/i.test(city)) return true;

  return false;
};

const normalizeListingKey = (listing) => {
  const title = String(listing.title || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
  const sellerId =
    listing.seller?._id || listing.seller?.id || listing.seller || "unknown";
  return `${title}:${sellerId}`;
};

export const dedupeListings = (listings = []) => {
  const seen = new Set();
  const result = [];

  listings.forEach((listing) => {
    const key = normalizeListingKey(listing);
    if (seen.has(key)) return;
    seen.add(key);
    result.push(listing);
  });

  return result;
};

export const filterMarketplaceListings = (
  listings = [],
  { relatedCategoryIds = [], relatedProductIds = [] } = {},
) => {
  const categorySet = new Set(
    relatedCategoryIds.map((id) => String(id)).filter(Boolean),
  );
  const productSet = new Set(
    relatedProductIds.map((id) => String(id)).filter(Boolean),
  );

  const cleaned = dedupeListings(listings).filter((listing) => {
    if (isTestListing(listing)) return false;

    if (categorySet.size === 0 && productSet.size === 0) {
      return true;
    }

    const listingCategory =
      listing.category?._id ||
      listing.category ||
      listing.product?.category?._id ||
      listing.product?.category;
    const listingProduct =
      listing.product?._id || listing.product?.id || listing.product;

    if (productSet.size > 0 && listingProduct) {
      return productSet.has(String(listingProduct));
    }

    if (categorySet.size > 0 && listingCategory) {
      return categorySet.has(String(listingCategory));
    }

    return categorySet.size === 0 && productSet.size === 0;
  });

  return cleaned;
};

export const formatListingTitle = (title) => {
  if (typeof title !== "string" || !title.trim()) return title;

  const brandFixes = {
    "ray-ban": "Ray-Ban",
    "ray ban": "Ray-Ban",
  };

  return title.replace(/\bray[-\s]?ban\b/gi, (match) => {
    const key = match.toLowerCase().replace(/\s+/g, " ");
    return brandFixes[key] || brandFixes["ray-ban"];
  });
};

export const formatViewCount = (count) => {
  const value = Number(count) || 0;
  return value === 1 ? "1 view" : `${value.toLocaleString()} views`;
};

export const formatListingPrice = (price) => {
  const value = Number(price);
  if (!Number.isFinite(value)) return null;
  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};
